"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _glyph = _interopRequireDefault(require("../glyph"));

var _excluded = ["id", "fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultProps = {
  fill: "icon-input"
};
var propTypes = {
  fill: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  id: _propTypes.string
};

var FormGlyph = function FormGlyph(_ref) {
  var id = _ref.id,
      fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    height: 24,
    width: 24
  }, props), /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    fill: fill,
    id: id
  }));
};

FormGlyph.propTypes = propTypes;
FormGlyph.defaultProps = defaultProps;
FormGlyph.displayName = "Modules.FormGlyph";
var _default = FormGlyph;
exports["default"] = _default;